import { render, staticRenderFns } from "./personalMenu.vue?vue&type=template&id=3d879e6e&scoped=true"
import script from "./personalMenu.vue?vue&type=script&lang=js"
export * from "./personalMenu.vue?vue&type=script&lang=js"
import style0 from "./personalMenu.vue?vue&type=style&index=0&id=3d879e6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d879e6e",
  null
  
)

export default component.exports